import type { WeightObject } from './globalTypes';

export type SignalRGenericMessageType =
  | 'None'
  | 'ShipmentLoadChange'
  | 'ShipmentLoadDispatched'
  | 'SmallParcelOrderProcessed'
  | 'FreightOrderProcessed'
  | 'DriverCheckedIn'
  | 'AppointmentStatusChanged'
  | 'AppointmentUnloaded'
  | 'PickJobAllocationChange'
  | 'InventoryTransferStatusChange';

type SignalRGenericMessagePayload = {
  Title: string;
  Message: 'string';
  DoorNumber?: string;
};

export interface SignalRGenericMessage {
  Type: SignalRGenericMessageType;
  Guid: string;
  Payload?: SignalRGenericMessagePayload;
  EntityID?: number;
}

export type ConnectionType = 'devices' | 'systemAlert' | 'systemMessage';

export type SubscribeAlertType =
  | 'ShipmentLoadChangesGroup'
  | 'OrderProcessingChangesGroup'
  | 'AppointmentStatusChangedGroup'
  | 'AppointmentUnloadedGroup'
  | 'DriverCheckedInGroup'
  | 'PickJobAllocationChangesGroup'
  | 'InventoryTransferStatusChangeGroup';

export type OnReadScale = (weightObject: WeightObject) => void;

export type OnConnectionSuccess = (connectionType: ConnectionType) => void;

export type OnConnectionError = (
  error: any,
  connectionType: ConnectionType,
) => void;

export type OnReconnecting = (
  isReconnecting: boolean,
  connectionType: ConnectionType,
) => void;

export type OnOrderBatchMessage = (message: BatchAlertMessage) => void;

export type OnDisconnected = (connectionType: ConnectionType) => void;

export type OnGenericMessage = (message: SignalRGenericMessage) => void;

interface BaseConnect {
  token: string;
  onConnectionSuccess: OnConnectionSuccess;
  onConnectionError: OnConnectionError;
  onReconnecting: OnReconnecting;
  onDisconnected: OnDisconnected;
}

export interface DeviceConnect extends BaseConnect {
  onReadScale: OnReadScale;
}

export interface MessagesConnect extends BaseConnect {
  onOrderBatchMessage: OnOrderBatchMessage;
  onFileImportComplete: (message: FileImportCompleteMessage) => void;
  onAllocateOrderInventoryCompleted: (
    message: AllocateOrderInventoryCompletedMessage,
  ) => void;
}

export interface AlertsConnect extends BaseConnect {
  onGenericMessage: OnGenericMessage;
}

export interface BatchAlertMessage {
  BatchID: number;
  Status: string;
}

export enum FileImportType {
  Order,
  Receipt,
  Bill,
  CustomerItem,
}

export enum FileImportStatus {
  Success,
  Failure,
}

export interface FileImportCompleteMessage {
  Guid: string;
  ImportType: FileImportType;
  Status: FileImportStatus;
  Message: string;
}

export interface AllocateOrderInventoryCompletedMessage {
  Guid: string;
  OrderID: number;
}
